export const useLinkLabels = () => {
  const labels = {
    lp: "Explorar modelo LP",
    natural: "Explorar modelo Gas Natural",
    electric: "Explorar modelo",
    sun: "Explorar modelo",
  }
  return labels
}
